/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/crop_image_asset" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCropImageAssetCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdCropImageAssetProps,
  EngagementAppGroupIdCropImageAssetResult,
} from "./types";

export const postEngagementAppGroupIdCropImageAsset = reactQueryMutationAdapter(
  engagementAppGroupIdCropImageAssetCacheKeys,
  ({
    appGroupId,
    cropH,
    cropW,
    cropX,
    cropY,
    newName,
    imageId,
  }: PostEngagementAppGroupIdCropImageAssetProps): Promise<EngagementAppGroupIdCropImageAssetResult> => {
    return fetch(`/engagement/${appGroupId}/crop_image_asset`, "POST", {
      crop_h: cropH,
      crop_w: cropW,
      crop_x: cropX,
      crop_y: cropY,
      image_id: imageId,
      new_name: newName,
    });
  }
);
